module.exports = __webpack_public_path__ + "static/media/truck.59846a90.svg";